module.exports = __webpack_public_path__ + "img/city-skyline.jpg";